import { jsx } from "react/jsx-runtime";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import { validateTidalLicense } from "../../base/index.js";
function AllInbox(props) {
  return /* @__PURE__ */ jsx(
    AllInboxIcon,
    {
      "data-testid": "AllInbox",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AllInbox",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
AllInbox.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "AllInbox"
};
validateTidalLicense();
export {
  AllInbox
};
//# sourceMappingURL=AllInbox.js.map
